import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import StepperFormModal from "./StepperFormModal";
import Topbar from "./Topbar";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import { FiMinimize } from "react-icons/fi";
import { setScreenType } from "../slices/globalVariableSlice";
import { useSaveFcmTokenMutation } from "../toolkitServices/userApi";
import { getMessagingInstance } from "../firebase";
import { getToken } from "firebase/messaging";
import GlobalMenuNavigator from "./GlobalMenuNavigator";

/* --- Menus (unchanged) --- */
const stockMenu = [
  { title: "LABELLED", link: "/stocks/labelled-stock-list" },
  { title: "UNLABELLED", link: "/stocks/unlabelled-stock-list" },
];
const adminMenu = [
  { title: "TENANTS", link: "/admin/tenant-list" },
  { title: "ENQUIRIES", link: "/admin/enquiry-list" },
  { title: "INVOICE TEMPLATES", link: "/admin/invoice-templates" },
  { title: "RECEIPT TEMPLATES", link: "/admin/receipt-templates" },
  { title: "ESTIMATE TEMPLATES", link: "/admin/est-templates" },
  { title: "QUOTATION TEMPLATES", link: "/admin/quotation-template" },
  { title: "URD TEMPLATES", link: "/admin/urd-template" },
];
const salesMenu = [{ title: "SALES", link: "/sales/sales-list" }];
const quotationMenu = [
  { title: "QUOTATIONS", link: "/quotations/quotation-list" },
];
const purchaseMenu = [{ title: "URD", link: "/purchase/urd-gst-list" }];
const transferMenu = [
  { title: "LABELLED STOCK TRANSFER", link: "/transfers" },
  {
    title: "UNLABELLED STOCK TRANSFER",
    link: "/transfers/unlabelled-transfers",
  },
];
const masterMenu = [
  { title: "CATEGORY", link: "/masters/category-master-list" },
  { title: "PRODUCT", link: "/masters/product-master-list" },
  { title: "DESIGN", link: "/masters/design-master-list" },
  { title: "PURITY", link: "/masters/purity-master-list" },
  { title: "STONE", link: "/masters/stone-master-list" },
  { title: "DIAMOND", link: "/masters/diamond-master-list" },
  { title: "STONE ATTRIBUTE", link: "/masters/stone-attribute-master-list" },
  {
    title: "DIAMOND ATTRIBUTE",
    link: "/masters/diamond-attribute-master-list",
  },
  { title: "RATE", link: "/masters/daily-rate-list" },
  // { title: "DIAMOND-SIEVE", link: "/masters/diamond-sieve-master-list" },
  // { title: "DIAMOND-SIZE", link: "/masters/diamond-size-master-list" },

  // {
  //   title: "ATTRIBUTE",
  //   children: [

  //   ],
  // },
  // {
  //   title: "OTHER",
  //   children: [
  //   ],
  // },
];
const organisationMenu = [
  { title: "COMPANY", link: "/organisation/company-master-list" },
  { title: "BRANCH", link: "/organisation/branch-master-list" },
  { title: "COUNTER", link: "/organisation/counter-master-list" },
  { title: "ROLE", link: "/organisation/role-master-list" },
  { title: "DEPARTMENT", link: "/organisation/department-master-list" },
  { title: "BANK", link: "/organisation/bank-master-list" },
  { title: "RFID", link: "/organisation/rfid-master/list" },
];

const whatsappCommerceMenu = [
  { title: "SETUP", link: "/whatsapp/setup" },
  { title: "CATALOG", link: "/whatsapp/catalog" },
  { title: "ORDERS", link: "/whatsapp/orders" },
];

const reportsMenu = [
  { title: "LABELLED", link: "/reports/stock-report" },
  { title: "UNLABELLED", link: "/reports/unlabelled-stock-report" },
  { title: "URD", link: "/reports/urd-report" },
  { title: "SALE", link: "/reports/sale-report" },
  { title: "CASH", link: "/reports/cash-report" },
  { title: "WALLET", link: "/reports/wallet-report" },
  { title: "OUTSTANDING", link: "/reports/cre-debt-report" },
  { title: "GST", link: "/reports/gst-report" },
  { title: "GST RETURN", link: "/reports/gst-return-report" },
  { title: "DELETED INV", link: "/reports/deleted-invoices-report" },
];
const membersMenu = [
  { title: "VENDOR", link: "/members/vendor-list" },
  { title: "CUSTOMER", link: "/members/customer-list" },
  { title: "EMPLOYEE", link: "/members/employee-list" },
];
const transactionsMenu = [
  { title: "ALL TRANSACTIONS", link: "/transactions/customer" },
  {
    title: "INVOICE TRANSACTIONS",
    link: "/transactions/customer/invoice-transaction",
  },
  {
    title: "SCHEME TRANSACTIONS",
    link: "/transactions/customer/schemes-transaction",
  },
  { title: "GENERAL TRANSACTIONS", link: "/transactions/customer/general" },
];
const designMenu = [
  { title: "LABEL", link: "/designs/label/List" },
  { title: "PRN", link: "/designs/prn-label-templates/list" },
];
const userManamementMenu = [
  { title: "USER PERMISSIONS", link: "/user-management/special-permissions" },
];
const savingSchemeMenu = [
  { title: "SAVING SCHEME", link: "/scheme/gold-scheme" },
  { title: "SCHEME ENROLLMENT", link: "/scheme/gold-scheme/enroll" },
];
const estimateMenu = [{ title: "ESTIMATES", link: "/estimate/estimate-list" }];
const settingMenu = [
  { title: "LABELLED STOCK", link: "/settings/labelled-module-fields" },
  { title: "UNLABELLED STOCK", link: "/settings/unlabelled-module-fields" },
  {
    title: "INV / QUOTATION / EST",
    link: "/settings/invoice-module-fields",
  },
  { title: "URD", link: "/settings/urd-module-fields" },
  // { title: "INV TEMPLATE", link: "/settings/invoice-template" },
  // { title: "EST TEMPLATE", link: "/settings/est-template" },
  // { title: "QUOT TEMPLATE", link: "/settings/quotation-template" },
  // { title: "URD TEMPLATE", link: "/settings/urd-template" },
  {
    title: "TEMPLATES",
    children: [
      { title: "INV TEMPLATE", link: "/settings/invoice-template" },
      { title: "EST TEMPLATE", link: "/settings/est-template" },
      { title: "QUOT TEMPLATE", link: "/settings/quotation-template" },
      { title: "URD TEMPLATE", link: "/settings/urd-template" },
      {
        title: "RECEIPT TEMPLATE",
        link: "/settings/receipt-template-settings",
      },
    ],
  },
  // { title: "URD TEMPLATE", link: "/settings/urd-template" },
  { title: "OTHER SETTINGS", link: "/settings/other-settings" },
];

/* --- helpers --- */
const getSectionFromPath = (p) =>
  p.startsWith("/stocks")
    ? "stocks"
    : p.startsWith("/sales")
      ? "sales"
      : p.startsWith("/masters")
        ? "masters"
        : p.startsWith("/organisation")
          ? "organisation"
          : p.startsWith("/reports")
            ? "reports"
            : p.startsWith("/members")
              ? "members"
              : p.startsWith("/transactions")
                ? "transactions"
                : p.startsWith("/designs")
                  ? "designs"
                  : p.startsWith("/user-management")
                    ? "userManagement"
                    : p.startsWith("/quotations")
                      ? "quotations"
                      : p.startsWith("/scheme")
                        ? "scheme"
                        : p.startsWith("/settings")
                          ? "admin"
                          : p.startsWith("/admin")
                            ? "admin"
                            : p.startsWith("/estimate")
                              ? "estimate"
                              : "dashboard";

const getMenuForSection = (s) =>
  ({
    stocks: stockMenu,
    sales: salesMenu,
    masters: masterMenu,
    organisation: organisationMenu,
    reports: reportsMenu,
    members: membersMenu,
    purchase: purchaseMenu,
    transfer: transferMenu,
    transactions: transactionsMenu,
    designs: designMenu,
    userManagement: userManamementMenu,
    quotations: quotationMenu,
    scheme: savingSchemeMenu,
    estimate: estimateMenu,
    settings: settingMenu,
    admin: adminMenu,
    "whatsapp-commerce": whatsappCommerceMenu,
  })[s] || [];

const globalNavigationSections = [
  { title: "Dashboard", items: [{ title: "DASHBOARD", link: "/dashboard" }] },
  {
    title: "Stocks",
    items: [
      { title: "LABELLED STOCK", link: "/stocks/labelled-stock-list" },
      { title: "UNLABELLED STOCK", link: "/stocks/unlabelled-stock-list" },
    ],
  },
  { title: "Sales", items: salesMenu },
  { title: "Quotations", items: quotationMenu },
  { title: "URD Purchase", items: purchaseMenu },
  { title: "Saving Scheme", items: savingSchemeMenu },
  {
    title: "Reports",
    items: reportsMenu.map((item) => ({
      ...item,
      title: `${item.title} REPORT`,
    })),
  },
  { title: "Transfer", items: transferMenu },
  { title: "Members", items: membersMenu },
  { title: "Transactions", items: transactionsMenu },
  {
    title: "Stock Verification",
    items: [{ title: "STOCK VERIFICATION", link: "/stock-validation" }],
  },
  { title: "Masters", items: masterMenu },
  { title: "Organisation", items: organisationMenu },
  { title: "Settings", items: settingMenu },
];

export default function AppLayout({ children, componentType }) {
  const dispatch = useDispatch();
  const screenType = useSelector((s) => s.globalVariables.screenType);
  const { pathname } = useLocation();

  const section = componentType || getSectionFromPath(pathname);
  const selectedMenu = getMenuForSection(section);

  const [modalOpen, setModalOpen] = useState(false);

  const [saveFcmToken] = useSaveFcmTokenMutation();

  useEffect(() => {
    const initFCM = async () => {
      try {
        if (typeof window === "undefined" || !("Notification" in window))
          return;

        const messaging = await getMessagingInstance();
        if (!messaging) return;

        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        const token = await getToken(messaging, {
          vapidKey:
            "BH8ql59ArEfaOYmP7vWbN6ftrzsj3rmR7vv6prSvzcyAQU8z-EJ8ehO8afFipe-78akG4ui72h3YX3Xakeysj24",
        });

        if (!token) return;

        const savedToken = localStorage.getItem("fcm_token");
        if (savedToken === token) return;

        await saveFcmToken(token);
        localStorage.setItem("fcm_token", token);
      } catch (error) {
        console.error("FCM init failed:", error);
      }
    };

    initFCM();
  }, [saveFcmToken]);
  return (
    <div className="min-h-dvh flex flex-col lg:flex-row relative bg-gradient-to-br from-[#f5f3ff] via-[#fefce8] to-[#e0f2fe]">
      {/* soft pastel background */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(196,181,253,0.28),transparent_55%),radial-gradient(circle_at_bottom,_rgba(251,191,36,0.18),transparent_55%)]" />
        <div className="absolute -top-24 left-8 h-64 w-64 rounded-full bg-[#c4b5fd]/35 blur-3xl" />
      </div>

      <StepperFormModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
      <GlobalMenuNavigator sections={globalNavigationSections} />

      {/* ✅ Sidebar handles desktop + mobile itself */}
      <Sidebar />

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-x-hidden">
        {/* ✅ Sticky Topbar for better mobile UX */}
        <motion.div
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.35 }}
          className={`sticky top-0 z-50 `}
        >
          <Topbar menu={selectedMenu} />
        </motion.div>

        {/* ✅ give bottom padding so mobile bottom-nav won't cover content */}
        <div className="flex-1 px-2 sm:px-4  pb-20 md:pb-0 overflow-auto ">
          {children}
        </div>
      </div>
    </div>
  );
}
